import React, { useState } from 'react';
import {
  Button,
  ButtonToolbar,
  Form,
  Modal,
} from 'rsuite';
import handleError from '../../api/apiErrorHandle';
import { showSuccessMessage } from '../../utils/message';
import { saveUserPassword } from './usersService';

interface Props {
  userId: number | undefined;
  onClose: () => void;
}

export default function UserPasswordDialog({ userId, onClose }: Props): JSX.Element {
  const [newPassword, setNewPassword] = useState<string>('');

  function handleClose(): void {
    setNewPassword('');
    onClose();
  }

  function handleSubmit(): void {
    if (userId === undefined) {
      return;
    }

    handleClose();

    saveUserPassword(userId, newPassword)
      .then(() => showSuccessMessage('Password updated!'))
      .catch(error => handleError(error));
  }

  return (
    <Modal open={userId !== undefined}>
      <Form layout="horizontal">
        <Form.Group controlId="newPassword">
          <Form.ControlLabel>New password</Form.ControlLabel>
          <Form.Control
            type="password"
            name="newPassword"
            onChange={(value: string) => setNewPassword(value)}
          />
        </Form.Group>
        <Form.Group>
          <ButtonToolbar>
            <Button appearance="primary" onClick={() => handleSubmit()}>
              Submit
            </Button>
            <Button appearance="ghost" onClick={() => handleClose()}>
              Cancel
            </Button>
          </ButtonToolbar>
        </Form.Group>
      </Form>
    </Modal>
  );
}
